import * as React from "react";

const TrialLicenseMediaTypeRadioItem = props => {
    // todo: selected prop
    // ..mediaType
    // ...rich content

    // trialLicenseProduct
    //  - TrialLicenseStatusTitle
    //  - TrialLicenseStatusText
    //  - MediaType
    //  - Product

    // other products

    if (!props.label) return null;
    return (
        <button
            type="button"
            className="trial-license-media-type-radio-btn"
            onClick={props.onClick}
            style={{
                position: "relative",
                padding: "5.5px 5.5px 5.5px 50px",
                width: "100%",
                cursor: "pointer",
                userSelect: "none"
            }}
        >
            <div
                className={[
                    "product-picker__item__radiowrap",
                    props.selected ? "radio__indicator--selected" : ""
                ].join(" ")}
            >
                <span className="radio__indicator"></span>
            </div>
            {props.label}
        </button>
    );
};

export default TrialLicenseMediaTypeRadioItem;
